import ProfessionalInfo from "@/components/ProfessionalInfo.vue";
import UserCredentialList from "@/components/UserCredentialList.vue";
import UserInfo from "@/components/UserInfo.vue";
import UserSubscriptionHistory from "@/components/UserSubscriptionHistory.vue";
import UserSubscriptionInfo from "@/components/UserSubscriptionInfo.vue";
import { repositories, useCases } from "@/core";
import ProfessionalPresentationMappers from "@/presentation/mappers/ProfessionalPresentationMappers";
import UserSubscriptionHistoryPresentationMappers from "@/presentation/mappers/UserSubscriptionTransactionPresentationMappers";

export default {
  components: {
    UserSubscriptionHistory,
    UserCredentialList,
    UserSubscriptionInfo,
    UserInfo,
    ProfessionalInfo,
  },
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  created() {
    window.addEventListener("resize", this.calculateWidth);
  },
  data() {
    // Permite abrir já na aba certa via query (?tab=profissional), ex.: o
    // link da lista de profissionais elegíveis manda direto pra essa aba.
    const validTabs = [
      "cadastro",
      "assinatura",
      "profissional",
      "prontuario",
      "receitas",
    ];
    return {
      item: {},
      id: this.$route.params.id,
      activeTab: validTabs.includes(this.$route.query.tab)
        ? this.$route.query.tab
        : "cadastro",
      loadingItems: false,
      loadingSubscriptions: false,
      loadingProfessional: false,
      professional: null,
      subscriptionTransactions: [],
      isCancelable: false,
      crmColumns: [
        { name: "Número" },
        { name: "UF" },
        { name: "Validado" },
        { name: "Ações" },
      ],
      columns: [
        {
          name: "Paciente",
          sortName: null,
          order: null,
        },
        {
          name: "Assinatura digital",
          sortName: null,
          order: null,
        },
        {
          name: "Data",
          sortName: null,
          order: null,
        },
        {
          name: "PDF",
          sortName: null,
          order: null,
        },
      ],
    };
  },
  methods: {
    async getData() {
      this.getSubscriptionHistory();
      try {
        let filters = {
          user_id: this.id,
        };
        const res = await repositories.userService.show(this.id, {
          address: true,
          device_information: true,
          crms: true,
        });
        const medicalRecords = await repositories.medicalRecordsService.list(
          filters,
        );
        const prescriptions = await repositories.prescriptionsService.list(
          filters,
        );

        let data = res.data;
        data.medicalRecords = medicalRecords.data;
        data.prescriptions = prescriptions.data;

        this.$set(this, "item", data);
        // GET admin/professionals/{userId} — o backend reverteu a rota, é
        // o id do usuário de novo (não precisa mais do professional_detail
        // embutido só pra bootstrapar esse fetch).
        if (data.type === "professional") {
          this.getProfessionalDetail(this.id);
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    async getProfessionalDetail(userId) {
      try {
        this.loadingProfessional = true;
        const res = await useCases.getProfessionalDetailUseCase.execute(userId);
        if (res) {
          this.$set(
            this,
            "professional",
            ProfessionalPresentationMappers.toViewModel(res),
          );
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingProfessional = false;
      }
    },
    onProfessionalUpdated() {
      // Refaz o GET (em vez de mesclar os campos localmente) — o
      // viewmodel tem campos derivados (statusBadge, rejectionStepLabel)
      // calculados na hora do mapeamento, que ficavam obsoletos com o
      // merge raso e só apareciam certos após um F5.
      this.getProfessionalDetail(this.id);
    },
    async getSubscriptionHistory() {
      try {
        this.loadingSubscriptions = true;
        const result =
          await useCases.listUserSubscriptionHistoryUseCase.execute(this.id);
        this.subscriptionTransactions =
          UserSubscriptionHistoryPresentationMappers.toListViewModel(result);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    openPDF(item) {
      if (item.pdf_url) {
        window.open(
          `${process.env.VUE_APP_IMG_BASE_URL}${item.pdf_url}`,
          "_blank",
        );
      }
    },
    async handlePremium() {
      this.$eventBus.$emit("showConfirmationAlert", {
        title: this.item.isPremium ? "Remover Premium" : "Tornar Premium",
        message: this.item.isPremium
          ? "Deseja remover a assinatura premium para este usuário?"
          : "Deseja dar uma assinatura premium para este usuário?",
        confirmCallback: async () => {
          try {
            this.loadingItems = true;
            if (this.item.isPremium) {
              await repositories.userService.unsubscribeUser({
                user_id: this.id,
              });
              this.$eventBus.$emit("showToast", {
                title: "Assinatura removida",
                msg: `Assinatura removida com sucesso`,
              });
            } else {
              await repositories.userService.subscribeUser({
                user_id: this.id,
              });
              this.$eventBus.$emit("showToast", {
                title: "Assinatura efetuada",
                msg: `Assinatura efetuada com sucesso`,
              });
            }
            this.getData();
          } catch (e) {
            console.log(e);
          }
        },
      });
    },
    async handleBlock() {
      this.$eventBus.$emit("showConfirmationAlert", {
        title: this.item.active ? "Bloquear Usuário" : "Desbloquear Usuário",
        message: this.item.active
          ? "Deseja bloquear este usuário?"
          : "Deseja desbloquear este usuário?",
        confirmCallback: async () => {
          try {
            this.loadingItems = true;
            await repositories.userService.update(this.id, {
              active: !this.item.active,
            });
            this.$eventBus.$emit("showToast", {
              title: this.item.active
                ? "Usuário bloqueado"
                : "Usuário desbloqueado",
              msg: this.item.active
                ? `Usuário bloqueado com sucesso`
                : "Usuário desbloqueado com sucesso",
            });
            this.getData();
          } catch (e) {
            console.log(e);
          }
        },
      });
    },
  },
};
